// Copyright (c) 2020 Deere & Company

import TabmWip from './components';
import actionCreators from './action-creators';
import {connect} from 'react-redux';
import reports from '../../routes/tabm/reports';

const getStateToBindToContainerProps = state => ({
    ...state.tabm.wip,
    links: state.app.links,
    reportsRoutes: reports,
    territories: state.user.territories,
    user: state.user.details
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {children, routeParams} = parentProps;

    const queryParams = parentProps.location.query;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        children,
        queryParams,
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(TabmWip);



// WEBPACK FOOTER //
// ./src/tabm/wip/state-connector.js